import { createReducer, on } from '@ngrx/store';
import { DipendentiActions } from './dipendenti.actions';
import {DatiAziendaDto, Utente} from '../../core/models/utente.mdoel';

export interface DipendentiState {
  items: Utente[];
  loading: boolean;
  error: string | null;

  datiAzienda: DatiAziendaDto | null;
  datiAziendaLoading: boolean;
  datiAziendaError: string | null;

  totalElements: number;
  totalPages: number;
  pageIndex: number;
  pageSize: number;

  selected: Utente | null;

  opLoading: boolean;
  opError: string | null;
}

export const initialState: DipendentiState = {
  items: [],
  loading: false,
  error: null,

  datiAzienda: null,
  datiAziendaLoading: false,
  datiAziendaError: null,

  totalElements: 0,
  totalPages: 0,
  pageIndex: 0,
  pageSize: 20,

  selected: null,

  opLoading: false,
  opError: null,
};

export const dipendentiReducer = createReducer(
  initialState,

  on(DipendentiActions.loadList, (s) => ({ ...s, loading: true, error: null })),
  on(DipendentiActions.loadListSuccess, (s, { items, totalElements, totalPages, pageIndex }) => ({
    ...s,
    loading: false,
    items,
    totalElements,
    totalPages,
    pageIndex,
  })),
  on(DipendentiActions.loadListFailure, (s, { error }) => ({ ...s, loading: false, error })),

  on(DipendentiActions.loadListPaginated, (s) => ({ ...s, loading: true, error: null })),
  on(DipendentiActions.loadListPaginatedSuccess, (s, { items, totalElements, totalPages, pageIndex }) => ({
    ...s,
    loading: false,
    items,
    totalElements,
    totalPages,
    pageIndex,
  })),
  on(DipendentiActions.loadListPaginatedFailure, (s, { error }) => ({ ...s, loading: false, error })),

  on(DipendentiActions.loadDetails, (s) => ({ ...s, opLoading: true, opError: null })),
  on(DipendentiActions.loadDetailsSuccess, (s, { item }) => ({ ...s, opLoading: false, selected: item })),
  on(DipendentiActions.loadDetailsFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(DipendentiActions.create, (s) => ({ ...s, opLoading: true, opError: null })),
  on(DipendentiActions.createSuccess, (s) => ({ ...s, opLoading: false })),
  on(DipendentiActions.createFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(DipendentiActions.loadDatiAzienda, s => ({
    ...s,
    datiAziendaLoading: true,
    datiAziendaError: null,
  })),

  on(DipendentiActions.loadDatiAziendaSuccess, (s, { item }) => ({
    ...s,
    datiAziendaLoading: false,
    datiAzienda: item,
  })),

  on(DipendentiActions.loadDatiAziendaFailure, (s, { error }) => ({
    ...s,
    datiAziendaLoading: false,
    datiAziendaError: error,
  })),

  on(DipendentiActions.updateDatiAzienda, s => ({
    ...s,
    datiAziendaLoading: true,
    datiAziendaError: null,
  })),

  on(DipendentiActions.updateDatiAziendaSuccess, s => ({
    ...s,
    datiAziendaLoading: false,
  })),

  on(DipendentiActions.updateDatiAziendaFailure, (s, { error }) => ({
    ...s,
    datiAziendaLoading: false,
    datiAziendaError: error,
  })),

  on(DipendentiActions.uploadLogoDatiAziendaFailure, (s, { error }) => ({
    ...s,
    datiAziendaError: error,
  })),

  );
